import { fg } from '@confluence/feature-gating';
import { useSessionData } from '@confluence/session-data/entry-points/useSessionData.ts';
import { AccessStatus } from '@confluence/session-data/entry-points/SiteInformationQuery.ts';
import { isMobileUserAgent, shouldShowMobileWeb } from '@confluence/mobile-detection';

export const useIsLoomBetaEnabled = (): boolean => {
	const { accessStatus } = useSessionData();
	const isConfluenceLicensed =
		accessStatus === AccessStatus.LICENSED_ADMIN_ACCESS ||
		accessStatus === AccessStatus.LICENSED_USE_ACCESS;

	// don't enable entry points if user is on a mobile device or viewing mobile web
	const isMobileDeviceOrMobileWeb = isMobileUserAgent() || shouldShowMobileWeb();

	// oxlint-disable-next-line confluence-feature-gating/no-new-feature-gates
	return isConfluenceLicensed && !isMobileDeviceOrMobileWeb && fg('confluence_loom_beta_enabled');
};
